import { render, staticRenderFns } from "./ViewPurchase.vue?vue&type=template&id=c0caa7e6&"
import script from "./ViewPurchase.vue?vue&type=script&lang=js&"
export * from "./ViewPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ViewPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VForm,VSimpleTable})
